<style scoped>
</style>

<template>
  <div>
    <ul>
      <li v-for="item in list" :key="item.loginid">{{item.loginid}}</li>
    </ul>

    <Input v-model="current.loginid"></Input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [{ loginid: "liyc" }, { loginid: "zw" }],
      current: {
        loginid: ""
      }
    };
  },
  methods: {
    copy(data) {
      let str = JSON.stringify(data);
      return JSON.parse(str);
    }
  },
  mounted() {
    this.current = this.strUtils.jsonCopy(this.list)[0];
  }
};
</script>